import api from "../services/api";

export const getAnnouncements = () => api.get("Announcement/all");
export const createAnnouncement = (data: any) => api.post("Announcement", data);
export const updateAnnouncement = (id: string, data: any) => api.put(`Announcement/${id}`, data);
export const deleteAnnouncement = (id: string) => api.delete(`Announcement/${id}`);
